import { useMemo } from 'react';

import { ScrollableTabs } from './ScrollableTabs';
import { ScrollableTabsProps, TabConfiguration } from './types';

interface ScrollableFilteredTabsProps extends ScrollableTabsProps {
	filter: TabFilter;
}

export type TabFilter = (tab: TabConfiguration) => boolean;

export const tabsFilter = (
	tabs: TabConfiguration[],
	filter: TabFilter
): TabConfiguration[] => tabs.filter((tab) => filter(tab));

export const ScrollableFilteredTabs = ({
	filter,
	paddingStyle,
	tabsSettingType,
	tabs,
	onTabClick,
}: ScrollableFilteredTabsProps) => {
	const filteredTabsConfiguration = useMemo(
		() => tabsFilter(tabs, filter),
		[filter, tabs]
	);

	return (
		<ScrollableTabs
			paddingStyle={paddingStyle}
			tabsSettingType={tabsSettingType}
			tabs={filteredTabsConfiguration}
			onTabClick={onTabClick}
		/>
	);
};
